export const jobDetails={
        "job_id":"#2452",
        "from":"11/05/2023",
        "to":"15/05/2023",
        "deviceSelected":"s1-s10,m1-m19",
        "dataFormat":"JSON",
        "dbName":"colloc4",
        "dataSource":"DD"
}
